import { FormInputMultiline, DatePickerComponent, FormSelect, FormInput } from '../../../component/input/InputStyle';
import FormLabel from '../../../component/input/FormLabel.component';
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
import MenuItem from '@material-ui/core/MenuItem';
import Priorities from '../utils/Priorities';
import { Flags } from '../interfaces/Flags';
import ArraySelect from '../utils/Select';
import { FormInterface } from '../interfaces/FormComponent';

export default function FormComponent({ handleChange, initialValues, disabled, setFieldValue }: FormInterface) {

    const setFieldValueForm = (name: string, date: Date | string) => {
        if (setFieldValue) {
            setFieldValue(name, date);
        }
    }

    return (
        <>
            <FormLabel title="PROGRESSO" required={!disabled} >
                <FormInputMultiline
                    name="progress"
                    value={initialValues.progress}
                    onChange={handleChange}
                    disabled={disabled}
                    required
                />
            </FormLabel>
            <FormLabel title="ANOTAÇÕES" required={!disabled}>
                <FormInputMultiline
                    name="businessProcess"
                    value={initialValues.businessProcess}
                    onChange={handleChange}
                    disabled={disabled}
                    required
                />
            </FormLabel>
            <FormLabel title="PRIORIDADE" md={6} required={!disabled} >
                <FormSelect
                    name="priority"
                    value={initialValues.priority}
                    onChange={handleChange}
                    defaultValue="0"
                    disabled={disabled}
                    required
                >
                    <MenuItem value="0" disabled>Selecione</MenuItem>
                    {Priorities.map((priority: Flags, index: number) => {
                        return <MenuItem value={priority.value || index} key={index}>{priority.label}</MenuItem>
                    })}
                </FormSelect>
            </FormLabel>
            <FormLabel title="DATA/HORA PREV. RESOLUÇÃO" sm={6} required={!disabled}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePickerComponent
                        value={initialValues.solutionTime || null}
                        onChange={(date: Date | string) => setFieldValueForm('solutionTime', date)}
                        disabled={disabled}
                        renderInput={(props: any) => <FormInput {...props} />}
                    />
                </LocalizationProvider>
            </FormLabel>

            <FormLabel title="Uso Contigência" md={6} required={!disabled} >
                <FormSelect
                    name="contingency"
                    value={initialValues.contingency}
                    onChange={handleChange}
                    defaultValue="0"
                    disabled={disabled}
                    required
                >
                    <MenuItem value="0" disabled>Selecione</MenuItem>
                    {ArraySelect.map((select: Flags, index: number) => {
                        return <MenuItem value={select.value || index} key={index}>{select.label}</MenuItem>
                    })}
                </FormSelect>
            </FormLabel>

            <FormLabel title="Variação de Tempo" md={6} required={!disabled} >
                <FormSelect
                    name="variationTime"
                    value={initialValues.variationTime}
                    onChange={handleChange}
                    defaultValue="0"
                    disabled={disabled}
                    required
                >
                    <MenuItem value="0" disabled>Selecione</MenuItem>
                    {ArraySelect.map((select: Flags, index: number) => {
                        return <MenuItem value={select.value || index} key={index}>{select.label}</MenuItem>
                    })}
                </FormSelect>
            </FormLabel>
        </>
    )
}